/*
 * mv-recently-viewed.js — Jewellery by JF "Recently viewed" (client-side, localStorage)
 * -----------------------------------------------------------------------------
 * No backend / app. localStorage key `mv:rv` holds a JSON array of product
 * handles, most-recent-first.
 *
 * Boot (defer-loaded):
 *   1. Parse [data-mv-rv-config] JSON: { currentHandle, maxCount, cardSectionId }.
 *   2. RECORD: if currentHandle, move it to the front of the stored list,
 *      dedupe, cap stored length at 20, write back (all localStorage in try/catch).
 *   3. DISPLAY: take stored handles minus currentHandle, sliced to maxCount.
 *      For each (in order) fetch <root>products/<handle>?section_id=<cardSectionId>
 *      and append the returned HTML into [data-mv-rv-grid], preserving order.
 *      A 404 / error skips that handle AND prunes it from storage (deleted product).
 *      After >=1 card is inserted, reveal the section (remove `hidden`).
 *
 * Injected cards need no re-wiring: mv-cart.js / mv-wishlist.js delegate at
 * the document level. Never throws on a single fetch failure.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'mv:rv';
  var STORE_CAP = 20;

  function readStore() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function writeStore(arr) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {
      /* private mode / quota — ignore */
    }
  }

  function removeHandle(arr, handle) {
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] !== handle) out.push(arr[i]);
    }
    return out;
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function boot() {
    var section = document.querySelector('.mv-recently');
    var configEl = document.querySelector('[data-mv-rv-config]');
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }
    if (!config) return;

    var currentHandle = config.currentHandle || null;
    var maxCount = parseInt(config.maxCount, 10);
    if (isNaN(maxCount) || maxCount < 1) maxCount = 8;
    var cardSectionId = config.cardSectionId || 'mv-rv-card';

    // ---- RECORD current product ----
    var stored = readStore();
    if (currentHandle) {
      stored = removeHandle(stored, currentHandle);
      stored.unshift(currentHandle);
      if (stored.length > STORE_CAP) stored = stored.slice(0, STORE_CAP);
      writeStore(stored);
    }

    // ---- DISPLAY ----
    var grid = section ? section.querySelector('[data-mv-rv-grid]') : null;
    if (!grid) return;

    var toShow = currentHandle ? removeHandle(stored, currentHandle) : stored.slice();
    toShow = toShow.slice(0, maxCount);
    if (!toShow.length) return; // leave hidden

    var root = shopRoot();
    var inserted = 0;
    var pruned = false;
    var pending = toShow.length;

    function finalize() {
      if (pruned) {
        // Re-read to avoid clobbering a RECORD from another tab, then prune.
        var live = readStore();
        for (var i = 0; i < deadHandles.length; i++) {
          live = removeHandle(live, deadHandles[i]);
        }
        writeStore(live);
      }
      if (inserted > 0 && section) {
        section.removeAttribute('hidden');
      }
    }

    var deadHandles = [];
    // slots preserve fetch order regardless of network completion order.
    var slots = new Array(toShow.length);

    function flush() {
      for (var i = 0; i < slots.length; i++) {
        var slot = slots[i];
        if (slot && slot.html != null && !slot.done) {
          slot.done = true;
          var wrap = document.createElement('div');
          wrap.innerHTML = slot.html;
          while (wrap.firstChild) {
            grid.appendChild(wrap.firstChild);
          }
          inserted++;
        }
      }
    }

    function settle() {
      pending--;
      if (pending <= 0) {
        flush();
        finalize();
      }
    }

    toShow.forEach(function (handle, idx) {
      var url = root + 'products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(cardSectionId);
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) {
            if (res.status === 404) {
              deadHandles.push(handle);
              pruned = true;
            }
            return null;
          }
          return res.text();
        })
        .then(function (text) {
          if (text != null && text.replace(/\s/g, '') !== '') {
            slots[idx] = { html: text, done: false };
          }
        })
        .catch(function () {
          /* network error — skip this handle, do not prune (may be transient) */
        })
        .then(settle);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
